import React, { useState } from "react";
import { getInitials } from "../helpers/get-initials";
import { MeControlPlaceholder } from "../me-control-placeholder";
// Need to write it this way for webpack to correctly pick up the magic comment
// eslint-disable-next-line arrow-body-style
var NovaFluentWrapper = React.lazy(function () {
    return import(
    /* webpackPrefetch: true */
    "../nova-wrappers/nova-fluent-me-control-wrapper");
});
/**
 *
 * @param props MeControlProps
 * @param props.locale The locale to use for the control
 * @param props.handlers The event handlers for the control
 * @param props.currentAccount The current account to display
 * @param props.rememberedAccounts The remembered accounts to display
 * @param props.additionalLinks Additional links to display in the control
 * @param props.placeholderStyles The styles to apply to the placeholder
 * @param props.theme The theme to use for the Me Control (light or dark)
 * @returns MeControl component
 */
export var MeControl = function MeControl(_a) {
    var handlers = _a.handlers, currentAccount = _a.currentAccount, locale = _a.locale, theme = _a.theme, rememberedAccounts = _a.rememberedAccounts, additionalLinks = _a.additionalLinks, placeholderStyles = _a.placeholderStyles;
    var _b = useState(false), isPlaceholderClicked = _b[0], setIsPlaceholderClicked = _b[1];
    var PlaceholderComponent = (React.createElement(MeControlPlaceholder, { onClick: function () {
            setIsPlaceholderClicked(true);
            if (!currentAccount) {
                handlers.signIn();
            }
        }, initials: getInitials(currentAccount), placeholderStyles: placeholderStyles }));
    // TODO: if there is no current account but there are remembered accounts, we should show a dropdown to allow the user to pick one of the remembered accounts
    var renderFullControl = isPlaceholderClicked && currentAccount;
    return (React.createElement("div", null, renderFullControl ? (React.createElement(React.Suspense, { fallback: React.createElement("div", null, PlaceholderComponent) },
        React.createElement(NovaFluentWrapper, { startWithMenuOpened: true, locale: locale, theme: theme, handlers: handlers, placeholderComponent: PlaceholderComponent, currentAccount: currentAccount, rememberedAccounts: rememberedAccounts, additionalLinks: additionalLinks }))) : (PlaceholderComponent)));
};
